<template>
  <div class="talentRecruitment">
    <img src="/status/zhaoping.jpg">
    <div class="middle_talent">
      <div class="text">
        欢迎加入我们，与我们共创事业
      </div>
      <div class="border_"></div>
      <div class="title">
        我们为员工提供富有竞争力的薪酬福利和广阔的发展空间
      </div>
      <div class="card_list">
        <div class="card_info">
          <img src="/status/cxwb.png">
          <div class="card_text">诚信为本</div>
          <div class="card_title">无论在何时都应将言必信、行必正作为基本信条，自觉维护企业在社会形象。</div>
        </div>
        <div class="card_info">
          <img src="/status/tdjs.png">
          <div class="card_text">团队精神</div>
          <div class="card_title">鼓励员工尽心尽力为团体合作的长远利益而努力，从而增进相互之间的信任。</div>
        </div>
        <div class="card_info">
          <img src="/status/rt.png">
          <div class="card_text">认同、参与、共享</div>
          <div class="card_title">倡导创造价值、培植使命感、责任感、荣誉感和成就感，培养高素质人才。</div>
        </div>
      </div>
    </div>
    <div class="zpzw_list">
      <div class="text">
        招聘职位
      </div>
      <div class="border_"></div>
      <div class="title">
        加入我们的团队，共同创造医疗科技的未来
      </div>
      <div class="zpzw_box">
        <table class="el-table__body" style="width: 100%; text-align: center; border-collapse: collapse;">
          <thead>
          <th>岗位名称</th>
          <th>工作地点</th>
          <th>招聘人数</th>
          <th>查看详情</th>
          </thead>
          <tbody>
          <tr v-for="(item,index) in talentList" :key="index" class="row-tr">
            <td>{{ item.name }}</td>
            <td>{{ item.address }}</td>
            <td>{{ item.num }}</td>
            <td class="check" @click="toCheck(item)">点击查看</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <tail_menu></tail_menu>
  </div>
</template>

<script>
import {talentList} from '@/views/mock'
import tail_menu from "@/components/tail_menu";
export default {
  name: "talentRecruitment",
  components:{
    tail_menu,
  },
  data(){
    return{
      talentList:talentList
    }
  },
  methods: {
    toCheck(item) {
      this.$router.push({name: 'recruitInfo', query: {id: item.id}})
    }
  }
}
</script>

<style scoped lang="scss">
.talentRecruitment{
  img{
    width: 100%;
  }
  .middle_talent{
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 50px 0;
    .text {
      font-size: 24px;
      font-weight: 600;
      color: #4a7bac;
    }

    .border_ {
      margin-top: 10px;
      width: 50px;
      border: 1px solid #327ecb;
    }

    .title {
      margin-top: 10px;
      color: #15191d;
      opacity: 0.73;
      font-size: 14px;
    }
    .card_list{
      display: flex;
      margin-top: 30px;
      .card_info:first-child{
        margin-left: 0;
      }
      .card_info{
        background: rgb(222,237,248);
        margin-left: 30px;
        border-radius: 12px;
        width: 270px;
        padding: 40px 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        img{
          width: 50px;
        }
        .card_text{
          margin-top: 20px;
          font-size: 18px;
        }
        .card_title{
          text-align: center;
          margin-top: 30px;
          font-size: 14px;
        }
      }
    }
  }
}
.zpzw_list{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
  background: rgb(222,237,248);
  .text {
    font-size: 24px;
    font-weight: 600;
    color: #4a7bac;
  }

  .border_ {
    margin-top: 10px;
    width: 50px;
    border: 1px solid #327ecb;
  }

  .title {
    margin-top: 10px;
    color: #15191d;
    opacity: 0.73;
    font-size: 14px;
  }
  .zpzw_box{
    width: 1300px;
    margin: 0 auto;

    .title {
      font-size: 36px;
      font-weight: 600;
      margin: 50px 0;
      letter-spacing: 1px;
      text-align: center;
    }

    table {
      margin-top: 40px;

      th {
        font-weight: 600;
        margin-bottom: 30px;
        font-size: 15px;
        line-height: 50px;
      }

      .row-tr {
        line-height: 80px;

        td {
          border-bottom: 1.5px dashed #ccc;
        }

        .check {
          cursor: pointer;
        }

        .check:hover {
          color: #02b2b5;
        }
      }
    }

    tr:hover {
      background: white;
    }
  }
}
</style>
